"use strict";
var table = document.querySelector(".field");
var appendRowBtn = document.querySelector(".append-row");
var removeRowBtn = document.querySelector(".remove-row");
var appendColumnBtn = document.querySelector(".append-column");
var removeColumnBtn = document.querySelector(".remove-column");
var MIN = 2;
var MAX = 10;
var rows = table.rows.length;
var columns = table.rows[0].cells.length;
function appendRow() {
    if (rows >= MAX) return;
    var tr = document.createElement("tr");
    for(var i = 0; i < columns; i++){
        var td = document.createElement("td");
        tr.append(td);
    }
    table.append(tr);
    rows++;
    updateButtonsState();
}
function removeRow() {
    if (rows <= MIN) return;
    table.rows[rows - 1].remove();
    rows--;
    updateButtonsState();
}
function appendColumn() {
    if (columns >= MAX) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = table.rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            var td = document.createElement("td");
            row.append(td);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    columns++;
    updateButtonsState();
}
function removeColumn() {
    if (columns <= MIN) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = table.rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var row = _step.value;
            row.cells[columns - 1].remove();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    columns--;
    updateButtonsState();
}
function updateButtonsState() {
    appendRowBtn.disabled = rows >= MAX;
    removeRowBtn.disabled = rows <= MIN;
    appendColumnBtn.disabled = columns >= MAX;
    removeColumnBtn.disabled = columns <= MIN;
}
appendRowBtn.addEventListener("click", appendRow);
removeRowBtn.addEventListener("click", removeRow);
appendColumnBtn.addEventListener("click", appendColumn);
removeColumnBtn.addEventListener("click", removeColumn);
updateButtonsState();

//# sourceMappingURL=index.d57cf8d4.js.map
